import React from 'react';
import { Link } from 'react-router-dom';

const AboutUsSection = ({ name,        readMore
,title, subtitle, path,description,  description1, eContentLink, feedbackLink, imageUrl }) => {
  return (
    <section id="" style={{margin:'2em 1rem  !important'}} className="about-us Home-Page school-sk">
      <div className="container">
        <div className="col-sm-12 col-md-7">
          <h2>
            {title} <br />
            <span>{subtitle}</span>
          </h2>
          <p style={{textAlign:"justify"}}>{/<[a-z][\s\S]*>/i.test(description) ? <span dangerouslySetInnerHTML={{ __html: description }} /> : description}</p>
          
         <h3 style={{marginTop:"20px"}}>{name}</h3>

         {
          readMore === true ? (
            <Link to={path} className='link-about'>
           <button className='read-more-button-2'>Read More</button>
          </Link>
          ) :  (
            ""
          )
         }
       
          
         

          {/* {eContentLink==''&(
          <div className="dise-e-conten">
            <a href={eContentLink} className="epathsala">E-CONTENT</a>
            <a href={feedbackLink} className="epathsala">FEEDBACK FORM</a>
          </div>
          )} */}
        </div>
        <div className="col-sm-12 col-md-5 pull-right hidden-sm">
          <img className="about-section-img" src={imageUrl} alt="Campus Related Image" />
        </div>
      </div>
      
    </section>
  );
};

export default AboutUsSection;
